export const paymentStatuses = {
  RequiresPaymentMethod: 'RequiresPaymentMethod',
  RequiresConfirmation: 'RequiresConfirmation',
  RequiresAction: 'RequiresAction',
  Processing: 'Processing',
  RequiresCapture: 'RequiresCapture',
  Canceled: 'Canceled',
  Succeeded: 'Succeeded',
  Scheduled: 'Scheduled'
};
